export const SETUP_WORKFLOW = 'SETUP_WORKFLOW';
export const UPDATE_WORKFLOW_STATUS = 'UPDATE_WORKFLOW_STATUS';
export const SETUP_WORKFLOW_PAGENATION = 'SETUP_WORKFLOW_PAGENATION';
export const SETUP_WORKFLOW_ACTION_LOG = 'SETUP_WORKFLOW_ACTION_LOG';
export const SETUP_WORKFLOW_ACTION_PAGENATION = 'SETUP_WORKFLOW_ACTION_PAGENATION';
export const SETUP_WORKFLOW_FAILURE_LOG = 'SETUP_WORKFLOW_FAILURE_LOG';
export const SETUP_WORKFLOW_FAILURE_PAGENATION = 'SETUP_WORKFLOW_FAILURE_PAGENATION';



// WEBPACK FOOTER //
// ./src/views/Setup/WorkflowList/flow/actionType.js